import React from 'react'

import Modal from 'react-modal'
import { onEnter } from '../../utilities/accessibility/onEnter'
import useWindowDimensions from '../../hooks/useWindowDimensions'
import AccommodationDetail from './AccommodationDetail'

import '../../styles/scss/elements/accomodation-detail.scss'

Modal.setAppElement('#ylg-ms__listings-details')

const AccommodationDetailModal = ({ accommodation, toggleModal, isOpen }) => {
  const { width } = useWindowDimensions()

  return (
    <Modal
      id="accommodation-modal"
      parentSelector={() => document.getElementById('ylg-ms__listings-details')}
      isOpen={isOpen}
      onRequestClose={toggleModal}
      style={{
        overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 2000 },
        content: {
          width: width < 1024 ? '100%' : '90%',
          overflowX: 'hidden',
          margin: 'auto',
          maxWidth: 1280,
          zIndex: 2,
        },
      }}
    >
      <div
        className="modal-close"
        role="button"
        onClick={toggleModal}
        onKeyDown={(event) => onEnter(event, toggleModal)}
        tabIndex="0"
      />
      <AccommodationDetail accommodation={accommodation} />
    </Modal>
  )
}

export default AccommodationDetailModal
